// Dependencies

import { IonLoading } from '@ionic/react';
import styled from 'styled-components';

export const WrapperIonLoading = styled(IonLoading)``;
